import React, { Component } from 'react';
import { string, func } from 'prop-types';

class Notice extends Component {
  render () {
    return (
      <div className='notice' onClick={this.props.openModal} >
        <div className='wrap'>
          <h5>{this.props.question}</h5>
          <p>{this.props.intro} <strong>{this.props.title}</strong> &raquo;</p>
        </div>
      </div>
    );
  }
}

Notice.propTypes = { // validate props expected
  'openModal': func.isRequired,
  'title': string.isRequired,
  'question': string.isRequired
};

export default Notice;



// WEBPACK FOOTER //
// ./src/components/Banner/Notice.jsx